import React, { useEffect, useRef, useState } from 'react';
import './Button.scss';
import Button from './Button';
import FileInput from './FileUpload';
import ImagePreview from './ImagePreview';
import DeleteButton from './DeleteButton';

type ImageUploaderProps = {
  buttonText: string;
  existingWelcomeImageFileName?: string | null;
  existingWelcomeImageBlobName?: string | null;
  onSave: (
    selectedFile: File | null,
    selectedFileContents: string | null
  ) => Promise<boolean>;
  removeWelcomeImage: () => Promise<void>;
  isDeleting: boolean;
  accept?: string;
};

const ImageUploader: React.FC<ImageUploaderProps> = ({
  buttonText,
  existingWelcomeImageFileName,
  existingWelcomeImageBlobName,
  onSave,
  removeWelcomeImage,
  isDeleting,
  accept
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedFileContents, setSelectedFileContents] = useState<
    string | null
  >(null);
  const [filePreview, setFilePreview] = useState<string | ArrayBuffer | null>(
    null
  );
  const [saving, setSaving] = useState(false);

  const inputFile = useRef<HTMLInputElement>(null);

  const handleFileChange = (file: File | undefined) => {
    if (file) {
      setSelectedFile(file);
    }
  };

  useEffect(() => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          setFilePreview(reader.result);
          setSelectedFileContents(reader.result.toString().split(',')[1]);
        } else {
          console.error("Can't read that file");
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  }, [selectedFile]);

  const handleSave = async () => {
    setSaving(true);

    if (await onSave(selectedFile, selectedFileContents)) {
      setSelectedFile(null);
      setSelectedFileContents(null);
      if (inputFile.current) {
        inputFile.current.value = '';
      }
    }

    setSaving(false);
  };

  return (
    <>
      <div className="image-input">
        <FileInput
          accept={accept ?? 'image/*'}
          onChange={handleFileChange}
          text="Upload image"
        />
      </div>
      {selectedFile && (
        <div className="image-preview">
          <div>
            <img src={filePreview as string} alt="Selected" height="100px" />
          </div>
        </div>
      )}
      {selectedFile && (
        <div className="button-container single-button">
          <Button isLoading={saving} isSubmit={false} onClick={handleSave}>
            {buttonText}
          </Button>
        </div>
      )}
      {existingWelcomeImageBlobName && !selectedFile && (
        <>
          <ImagePreview
            existingFileName={existingWelcomeImageFileName}
            existingBlobName={existingWelcomeImageBlobName}
          />
          <DeleteButton
            type="Secondary"
            onClick={removeWelcomeImage}
            isLoading={isDeleting}
          >
            Remove image
          </DeleteButton>
        </>
      )}
    </>
  );
};

export default ImageUploader;
